import React, { memo, useMemo } from 'react'

import { bool, func, string } from 'prop-types'

import useDisabledSelector from 'Pods/ThreeDStudio/Hooks/useDisabledSelector'
import ButtonGroupSelector from 'Pods/ThreeDStudio/Shared/ButtonGroupSelector/ButtonGroupSelector'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

function GenericPolygonTypeSelector({
  handleQuadrilateralClick,
  handleTriangleClick,
  sliceName,
  storeSchemaKey,
  forceDisabled = false,
}) {
  const { isFullyDisabled, disabledValues } = useDisabledSelector('polygon_type', storeSchemaKey)

  const buttons = useMemo(() => [
    {
      id: POLYGON_TYPE.QUADRILATERAL,
      label: 'Quad',
      onClick: handleQuadrilateralClick,
      disabled: forceDisabled || isFullyDisabled || disabledValues.includes(POLYGON_TYPE.QUADRILATERAL),
    },
    {
      id: POLYGON_TYPE.TRIANGLE,
      label: 'Triangular',
      onClick: handleTriangleClick,
      disabled: forceDisabled || isFullyDisabled || disabledValues.includes(POLYGON_TYPE.TRIANGLE),
    },
  ], [
    forceDisabled,
    isFullyDisabled,
    disabledValues,
    handleQuadrilateralClick,
    handleTriangleClick,
  ])

  return (
    <ButtonGroupSelector
      buttons={buttons}
      keyName="polygonType"
      sliceName={sliceName}
      label="Polygon Type"
    />
  )
}

GenericPolygonTypeSelector.propTypes = {
  handleQuadrilateralClick: func.isRequired,
  handleTriangleClick: func.isRequired,
  sliceName: string.isRequired,
  storeSchemaKey: string.isRequired,
  forceDisabled: bool,
}

export default memo(GenericPolygonTypeSelector)
